import type { SectionStates } from '@/types/SectionState';

export const SECTION_STATES_DEFAULT: SectionStates = {
  outgoingProperties: 'simple',
  incomingProperties: 'simple',
  loanAmount: 'simple',
  applicantDetails: 'simple',
  income: 'simple',
  expenses: 'simple',
  assetsLiabilities: 'simple',
};
